import { type DepositCashFlowName } from 'features/moveMoney/providers/DepositCashFlowContextProvider';

export const getDepositCashFlowNameFromParam = (
  flowSource?: string | string[],
): DepositCashFlowName => {
  const normalizedFlowSource = Array.isArray(flowSource)
    ? flowSource[0]
    : flowSource;
  const flowSources: Record<string, DepositCashFlowName> = {
    onboarding: 'onboarding',
    move_money: 'move_money',
  };

  return flowSources[normalizedFlowSource ?? ''] ?? 'move_money';
};
